import qs from 'query-string';
import {
  API_ENDPOINT,
  type ClientApiV1PostsUserUserIdQueryString,
  useClientApiV1PostsUserUserIdQuery,
} from '../../resources/@types/uccSchema';

const DEFAULT_QUERY_PARAMS = {
  type: 'ALL',
  sort: 'RECENT',
  pageSize: 10,
  pageNumber: 1,
};

interface UseClientV1PostsUserUserIdQuery {
  userId: string;
  queryObject?: Partial<ClientApiV1PostsUserUserIdQueryString>;
  options?: Parameters<typeof useClientApiV1PostsUserUserIdQuery>[0]['options'];
}

export function usePostsUserUserIdQuery({
  userId,
  queryObject,
  options,
}: UseClientV1PostsUserUserIdQuery) {
  return useClientApiV1PostsUserUserIdQuery({
    queryKey: getUsePostsUserUserIdQueryQueryKey({ userId, ...queryObject }),
    url: getUsePostsUserUserIdQueryQueryUrl({ userId, ...queryObject }),
    options,
  });
}

export const getUsePostsUserUserIdQueryQueryKey = ({
  userId,
  ...queryObject
}: { userId: string } & Partial<ClientApiV1PostsUserUserIdQueryString>) => [
  API_ENDPOINT.CLIENT_V1_POSTS_USER_USERID(userId),
  { ...DEFAULT_QUERY_PARAMS, ...queryObject },
];

export const getUsePostsUserUserIdQueryQueryUrl = ({
  userId,
  ...queryObject
}: { userId: string } & Partial<ClientApiV1PostsUserUserIdQueryString>) =>
  qs.stringifyUrl({
    url: API_ENDPOINT.CLIENT_V1_POSTS_USER_USERID(userId),
    query: { ...DEFAULT_QUERY_PARAMS, ...queryObject },
  });
